import { apiFetch } from './api';

/**
 * List all quotations
 */
export function listQuotations(params = {}) {
  const queryParams = new URLSearchParams();
  if (params.status) queryParams.append('status', params.status);
  if (params.search) queryParams.append('search', params.search);
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.myReviewQueue === true || params.myReviewQueue === 'true') queryParams.append('myReviewQueue', 'true');
  if (params.myApprovalQueue === true || params.myApprovalQueue === 'true') queryParams.append('myApprovalQueue', 'true');
  if (params.attentionOnly === true || params.attentionOnly === 'true') queryParams.append('attentionOnly', 'true');
  
  const queryString = queryParams.toString();
  return apiFetch(`/api/admin/quotations${queryString ? `?${queryString}` : ''}`);
}

/**
 * Get quotation details
 */
export function getQuotation(id) {
  return apiFetch(`/api/admin/quotations/${id}`);
}

/**
 * Update quotation
 */
export function updateQuotation(id, data) {
  return apiFetch(`/api/admin/quotations/${id}`, {
    method: 'PATCH',
    body: data
  });
}

/**
 * Update quotation status
 */
export function updateQuotationStatus(id, status, notes) {
  return apiFetch(`/api/admin/quotations/${id}/status`, {
    method: 'POST',
    body: { status, notes }
  });
}

/**
 * Assign staff to quotation
 */
export function assignStaff(id, reviewerId, approverId) {
  return apiFetch(`/api/admin/quotations/${id}/assign`, {
    method: 'POST',
    body: { reviewerId, approverId }
  });
}

/**
 * Update quotation fees
 */
export function updateQuotationFees(id, fees) {
  return apiFetch(`/api/admin/quotations/${id}/fees`, {
    method: 'PUT',
    body: fees
  });
}

/**
 * Approve quotation
 */
export function approveQuotation(id) {
  return apiFetch(`/api/admin/quotations/${id}/approve`, {
    method: 'POST'
  });
}

/**
 * Reject quotation
 */
export function rejectQuotation(id, reason) {
  return apiFetch(`/api/admin/quotations/${id}/reject`, {
    method: 'POST',
    body: { reason }
  });
}

/**
 * Archive quotation
 */
export function archiveQuotation(id) {
  return apiFetch(`/api/admin/quotations/${id}/archive`, {
    method: 'POST'
  });
}

/**
 * Get quotation statistics
 */
export function getQuotationStats() {
  return apiFetch('/api/admin/quotations/stats');
}

/**
 * Save note for quotation
 */
export function saveQuotationNote(id, note) {
  return apiFetch(`/api/admin/quotations/${id}`, {
    method: 'PATCH',
    body: { note }
  });
}

/**
 * Request additional info for quotation
 */
export function requestQuotationAdditionalInfo(id, payload) {
  return apiFetch(`/api/admin/quotations/${id}/additional-info-request`, {
    method: 'POST',
    body: payload
  });
}

/**
 * List messages for quotation
 */
export function listQuotationMessages(quotationId, params = {}) {
  const queryParams = new URLSearchParams();
  if (params.type) queryParams.append('type', params.type);
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  
  const queryString = queryParams.toString();
  return apiFetch(`/api/admin/quotations/${quotationId}/messages${queryString ? `?${queryString}` : ''}`);
}

/**
 * Send message for quotation (customer or internal; use /internal for staff-only)
 */
export function sendQuotationMessage(quotationId, payload) {
  return apiFetch(`/api/admin/quotations/${quotationId}/messages`, {
    method: 'POST',
    body: payload
  });
}

/**
 * Send internal (staff-only) message for quotation
 */
export function sendQuotationInternalMessage(quotationId, payload) {
  return apiFetch(`/api/admin/quotations/${quotationId}/messages/internal`, {
    method: 'POST',
    body: payload
  });
}

/**
 * Mark quotation as reviewed
 */
export function markQuotationAsReviewed(id) {
  return apiFetch(`/api/admin/quotations/${id}/mark-reviewed`, {
    method: 'POST'
  });
}

/**
 * Send quotation back to reviewer
 */
export function sendQuotationBackToReviewer(id, data) {
  return apiFetch(`/api/admin/quotations/${id}/send-back-to-reviewer`, {
    method: 'POST',
    body: data
  });
}

/**
 * Add a note to a quotation (same as licence notes)
 */
export function addQuotationNote(quotationId, note) {
  return apiFetch(`/api/admin/quotations/${quotationId}/notes`, {
    method: 'POST',
    body: { note }
  });
}

/**
 * List documents for a quotation
 */
export function listQuotationDocuments(quotationId) {
  return apiFetch(`/api/admin/quotations/${quotationId}/documents`);
}

/**
 * Create (upload) a support document for a quotation
 */
export function createQuotationDocument(quotationId, payload) {
  return apiFetch(`/api/admin/quotations/${quotationId}/documents`, {
    method: 'POST',
    body: payload
  });
}

